import React from "react";
import { Loader2, Building2, Search } from "lucide-react";
import { inputCls, REFERENCES } from "./constants";
import { usePackagerNames } from "./usePackagerNames";

export const Step3ContactDetails = ({ form, onSet, error, companySearch }) => {
  const { companyResults, searchingCo, showCoDropdown, setShowCoDropdown, search } = companySearch;
  const packagers = usePackagerNames();

  const onBusinessNameChange = (v) => {
    onSet("business_name", v, { company_number: "", company_address: "" });
    search(v);
  };

  const pickCompany = (c) => {
    onSet("business_name", c.name, { company_number: c.number, company_address: c.address });
    setShowCoDropdown(false);
  };

  return (
    <div className="space-y-5">
      <h3 className="font-display text-2xl font-extrabold tracking-tight mb-1">Where do we send your options?</h3>
      <div className="grid sm:grid-cols-2 gap-4">
        <input className={inputCls} placeholder="Full name" value={form.full_name}
          onChange={(e) => onSet("full_name", e.target.value)} data-testid="input-name" />
        <div className="relative">
          <input className={inputCls} placeholder="Business name" value={form.business_name}
            onChange={(e) => onBusinessNameChange(e.target.value)}
            onFocus={() => companyResults.length > 0 && !form.company_number && setShowCoDropdown(true)}
            data-testid="input-business" autoComplete="off" />
          {searchingCo && (
            <Loader2 size={16} className="animate-spin absolute right-2 top-4 text-[#052F24]/40" />
          )}
          {showCoDropdown && companyResults.length > 0 && (
            <div className="absolute z-30 left-0 right-0 top-full mt-1 bg-white rounded-xl border border-[#E5E5E0] shadow-[0_16px_40px_-16px_rgba(5,47,36,0.35)] max-h-64 overflow-y-auto" data-testid="company-dropdown">
              <p className="flex items-center gap-1.5 px-3.5 pt-3 pb-1.5 text-[10px] font-bold tracking-[0.15em] uppercase text-[#052F24]/45">
                <Search size={11} /> Companies House matches
              </p>
              {companyResults.map((c) => (
                <button key={c.number} type="button" onClick={() => pickCompany(c)}
                  data-testid={`company-option-${c.number}`}
                  className="w-full text-left px-3.5 py-2.5 hover:bg-[#052F24]/5 transition-colors border-t border-[#052F24]/5">
                  <span className="block text-sm font-semibold text-[#052F24]">{c.name}</span>
                  <span className="block text-xs text-[#052F24]/50 truncate">{c.number} · {c.address}</span>
                </button>
              ))}
              <button type="button" onClick={() => setShowCoDropdown(false)}
                data-testid="company-skip-btn"
                className="w-full text-left px-3.5 py-2.5 text-xs font-semibold text-[#052F24]/60 hover:bg-[#052F24]/5 border-t border-[#052F24]/5 transition-colors">
                Can't see your business? Continue with "{form.business_name}"
              </button>
            </div>
          )}
          {form.company_number && (
            <p className="flex items-center gap-1.5 mt-1.5 text-xs font-semibold text-[#052F24]/70" data-testid="company-verified">
              <Building2 size={12} className="text-[#052F24]" /> Registered company · {form.company_number}
            </p>
          )}
        </div>
      </div>
      <input className={inputCls} type="email" placeholder="Email address" value={form.email}
        onChange={(e) => onSet("email", e.target.value)} data-testid="input-email" />
      <input className={inputCls} placeholder="Phone number" value={form.phone}
        onChange={(e) => onSet("phone", e.target.value)} data-testid="input-phone" />
      <div>
        <label className="block text-[11px] font-bold tracking-[0.2em] text-[#052F24]/50 uppercase mb-2">
          Underwriter <span className="font-normal tracking-normal text-[#052F24]/35">(optional)</span>
        </label>
        <select
          value={form.referred_by}
          onChange={(e) => onSet("referred_by", e.target.value)}
          data-testid="input-referred-by"
          className="w-full bg-transparent border-b-2 border-[#052F24]/15 focus:border-[#052F24] outline-none py-3 text-lg font-light text-[#052F24] transition-colors cursor-pointer"
        >
          <option value="">Select an underwriter…</option>
          {REFERENCES.map((r) => (
            <option key={r} value={r}>{r}</option>
          ))}
        </select>
      </div>
      {packagers.length > 0 && (
        <div>
          <label className="block text-[11px] font-bold tracking-[0.2em] text-[#052F24]/50 uppercase mb-2">
            Packager <span className="font-normal tracking-normal text-[#052F24]/35">(optional)</span>
          </label>
          <select
            value={form.packager}
            onChange={(e) => onSet("packager", e.target.value)}
            data-testid="input-packager"
            className="w-full bg-transparent border-b-2 border-[#052F24]/15 focus:border-[#052F24] outline-none py-3 text-lg font-light text-[#052F24] transition-colors cursor-pointer"
          >
            <option value="">Select a packager…</option>
            {packagers.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </div>
      )}
      {error && <p className="text-sm text-red-600" data-testid="lead-error">{error}</p>}
    </div>
  );
};
